"use client"

import { Images } from "@/constants/images"
import { buildFacebookShareUrl, buildTwitterShareUrl, openShareWindow } from "@/constants/social-share"
import { t } from "@/languages/i18n"
import Image from "next/image"

type SocialShareButtonsProps = {
  facebook?: string
  twitter?: string
}

export default function SocialShareButtons({ facebook, twitter }: SocialShareButtonsProps) {
  if (!facebook && !twitter) return null

  const handleFacebookShare = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    if (facebook) {
      openShareWindow(buildFacebookShareUrl(facebook))
    }
  }

  const handleTwitterShare = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    if (twitter) {
      openShareWindow(buildTwitterShareUrl(twitter))
    }
  }

  return (
    <div className="flex sm:gap-2 gap-1 sm:items-center items-center sm:pt-5 sm:pb-[50px] py-5">
      <span className="text-public-fg text-base leading-[24.8px] font-bold mr-2">{t("Chia sẻ")}:</span>
      {facebook && (
        <button
          onClick={handleFacebookShare}
          // WCAG min tap target 44×44. Visible icon stays 31×31 but the
          // button itself is larger so touch devices can hit it reliably.
          className="inline-flex items-center justify-center w-11 h-11 rounded-full text-public-fg hover:text-public-brand hover:bg-public-brand/10 transition-colors cursor-pointer"
          aria-label={t("Chia sẻ qua Facebook")}
          type="button"
        >
          <Image src={Images.facebookIcon} alt="" aria-hidden="true" width={31} height={31} />
        </button>
      )}

      {twitter && (
        <button
          onClick={handleTwitterShare}
          className="inline-flex items-center justify-center w-11 h-11 rounded-full text-public-fg hover:text-public-brand hover:bg-public-brand/10 transition-colors cursor-pointer"
          aria-label={t("Chia sẻ qua Twitter")}
          type="button"
        >
          <Image src={Images.twitterIcon} alt="" aria-hidden="true" width={31} height={31} />
        </button>
      )}
    </div>
  )
}
